<template>
  <RevLoadingScreen
    class="fixed inset-0"
    data-qa="loading-screen"
    data-test="loading-screen"
    :text="i18n(translations.loading)"
  />
</template>

<script lang="ts" setup>
import { useHead } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import { useLogin } from '../composables/useLogin'

import translations from './LoginPage.translations'

type Props = {
  redirectionPathname: string
  bmJourney?: string | null
  bmAutoStartProvider?: string | null
}

const props = defineProps<Props>()

const i18n = useI18n()
const logger = useLogger()
const locale = useI18nLocale()

useHead({
  htmlAttrs: {
    lang: locale,
  },
})

useLogin({
  redirectionPathname: props.redirectionPathname,
  bmJourney: props.bmJourney,
  bmAutoStartProvider: props.bmAutoStartProvider,
  onError(error) {
    if (error instanceof Error) {
      logger.error('Something failed while logging in', {
        error,
        owners: ['bot-squad-identity'],
      })
    }
  },
})
</script>
